import { useState } from "react";
import api, { formatApiError } from "../lib/api";
import { Button } from "./ui/button";
import { Loader2, ArrowRightLeft, Search } from "lucide-react";
import { toast } from "sonner";

const total = (counts, k = "file") => Object.values(counts || {}).reduce((a, c) => a + c[k], 0);

const Summary = ({ info }) => (
  <div className="text-xs space-y-1" data-testid="b2-migrate-result">
    <p>{info.dry_run ? "Record che verranno aggiornati" : "Record aggiornati"}: <strong data-testid="b2-migrate-total">{total(info.counts)}</strong> file · <strong>{total(info.counts, "miniature")}</strong> miniature → bucket <strong>{info.bucket}</strong></p>
    {Object.entries(info.counts).map(([c, v]) => <p key={c} className="text-muted-foreground">{c}: {v.file} file, {v.miniature} miniature</p>)}
    {info.checked > 0 && !info.missing.length && <p className="text-emerald-500">Controllati su B2: {info.checked} file presenti</p>}
    {info.missing.length > 0 && <p className="text-amber-500" data-testid="b2-migrate-missing">Attenzione: {info.missing.length} file di controllo non trovati su B2 (es. {info.missing[0]})</p>}
  </div>
);

export const B2RelinkPanel = () => {
  const [busy, setBusy] = useState(false);
  const [info, setInfo] = useState(null);

  const run = async (dry) => {
    if (!dry && !window.confirm(`Aggiornare ${total(info.counts)} record da Wasabi a Backblaze B2? I file fisici non vengono toccati.`)) return;
    setBusy(true);
    try {
      const { data } = await api.post("/admin/storage/relink-wasabi-to-b2", { dry_run: dry });
      setInfo(data);
      if (!dry) toast.success(`Migrazione completata: ${total(data.counts)} file ora su Backblaze B2`);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="mt-4 rounded-lg border border-amber-500/40 p-4 text-sm space-y-3" data-testid="b2-migrate-panel">
      <p className="text-foreground font-semibold">Migra file da Wasabi a B2</p>
      <p className="text-xs text-muted-foreground">Aggiorna nel database i record con storage "wasabi" impostandoli su Backblaze B2 (bucket configurato). I file fisici su Backblaze non vengono modificati. Esegui prima la simulazione.</p>
      {info && <Summary info={info} />}
      <div className="flex flex-wrap gap-2">
        <Button variant="outline" size="sm" disabled={busy} onClick={() => run(true)} data-testid="b2-migrate-dryrun">
          {busy ? <Loader2 className="h-4 w-4 animate-spin mr-1" /> : <Search className="h-4 w-4 mr-1" />} Simula migrazione (dry-run)
        </Button>
        <Button size="sm" disabled={busy || !info?.dry_run || total(info.counts) + total(info.counts, "miniature") === 0} onClick={() => run(false)} data-testid="b2-migrate-apply" className="bg-amber-500 hover:bg-amber-600 text-[#0a0d14] font-semibold">
          <ArrowRightLeft className="h-4 w-4 mr-1" /> Migra file da Wasabi a B2
        </Button>
      </div>
    </div>
  );
};
